import axios from "axios";

const API_BASE =
    process.env.REACT_APP_API_URL || "https://localhost:7231";

axios.defaults.withCredentials = true;

export async function getCurrentUser() {
    const response = await axios.get(
        `${API_BASE}/api/auth/me`,
        {
            withCredentials: true
        }
    );

    return response.data;
}

export async function logout() {
    await axios.post(
        `${API_BASE}/api/auth/logout`,
        {},
        {
            withCredentials: true
        }
    );
}

export function redirectToLogin(returnUrl = window.location.href) {
    const encoded = encodeURIComponent(returnUrl);
    window.location.href = `https://admin.shrianshnexus.in/login?entry=public&returnUrl=${encoded}`;
}

export function redirectToSignup(returnUrl = window.location.href) {
    const encoded = encodeURIComponent(returnUrl);
    window.location.href = `https://admin.shrianshnexus.in/signup?entry=public&returnUrl=${encoded}`;
}